import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/lib/api'
import { useT } from '@/i18n/I18nProvider'

interface Rule {
  id: string; version: string; category: string; severity: string; scope: string
  description: string; docsUrl: string; status: string
}

export function AdminRulesPage() {
  const t = useT()
  const rules = useQuery({
    queryKey: ['admin-rules'],
    queryFn: () => apiClient.get<{ data: Rule[] }>('/admin/rules'),
  })

  if (rules.isLoading) return <p>{t('common.loading')}</p>
  if (rules.isError || !rules.data) return <p>{t('common.error')}</p>

  const grouped = new Map<string, Rule[]>()
  for (const r of rules.data.data) {
    const arr = grouped.get(r.category) ?? []
    arr.push(r)
    grouped.set(r.category, arr)
  }

  return (
    <div>
      <h1 className="text-2xl font-semibold mb-1">{t('admin.rules.title')}</h1>
      <p className="text-xs opacity-70 mb-6">{t('admin.rules.subtitle', { count: rules.data.data.length })}</p>
      {Array.from(grouped.entries()).map(([cat, list]) => (
        <section key={cat} className="mb-6">
          <h2 className="text-sm font-medium opacity-80 mb-2">{cat}</h2>
          <table className="w-full text-sm border-collapse">
            <thead><tr className="text-left opacity-70"><th className="py-1 pr-4">id</th><th className="py-1 pr-4">severity</th><th className="py-1 pr-4">scope</th><th className="py-1 pr-4">version</th><th className="py-1 pr-4">status</th></tr></thead>
            <tbody>
              {list.map((r) => (
                <tr key={r.id} className="border-t" style={{ borderColor: 'var(--color-border)' }}>
                  <td className="py-1 pr-4 font-mono text-xs">{r.id}</td>
                  <td className="py-1 pr-4">{r.severity}</td>
                  <td className="py-1 pr-4">{r.scope}</td>
                  <td className="py-1 pr-4">{r.version}</td>
                  <td className="py-1 pr-4">{r.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      ))}
    </div>
  )
}
